import { useAuth } from "../context/AuthContext";
import GoldSectionLayout from "../components/GoldSectionLayout";
import GoldMatchDossier from "../components/GoldMatchDossier";

export default function GoldDossierPage() {
  const { token } = useAuth();
  return (
    <GoldSectionLayout
      title="Match Dossier"
      subtitle="Pick a fixture — the full 20-layer institutional stack auto-populates."
      testid="gold-dossier-page"
    >
      <GoldMatchDossier token={token} />
    </GoldSectionLayout>
  );
}
